import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { AdminSidebar } from './AdminSidebar';
import { Button } from '@/components/ui/button';
import { Menu } from 'lucide-react';
import { ScrollToTop } from '@/components/shared/ScrollToTop';
import { Toaster } from '@/components/ui/sonner';

export const AdminLayout = () => {
  const [open, setOpen] = useState(false);
  return (
    <div className="min-h-screen flex bg-secondary/40" data-testid="admin-layout">
      <ScrollToTop />
      <AdminSidebar open={open} onClose={() => setOpen(false)} />
      <div className="flex-1 min-w-0">
        <header className="sticky top-0 z-30 bg-background/85 backdrop-blur-xl border-b border-border/60 px-4 py-3 flex items-center justify-between lg:hidden">
          <Button variant="ghost" size="icon" onClick={() => setOpen(true)} data-testid="admin-menu-trigger">
            <Menu className="h-5 w-5" />
          </Button>
          <span className="font-heading font-semibold">Admin Portal</span>
          <span />
        </header>
        <main className="p-4 sm:p-6 lg:p-8 pb-16">
          <Outlet />
        </main>
      </div>
      <Toaster position="top-right" richColors closeButton />
    </div>
  );
};
